import React, { useRef } from 'react';
import { useIntl } from 'react-intl';
import { componentMessages } from '../../component-translations';
export const UserContextErrorPage = (props) => {
    const { errorCode, CustomErrorPage } = props;
    const { formatMessage } = useIntl();
    const errorMapping = useRef({
        FAILED_ME: formatMessage(componentMessages['user.me.error']),
        FAILED_FEATURES: formatMessage(componentMessages['user.features.error']),
        INCORRECT_MODULE: formatMessage(componentMessages['user.features.incorrectModule']),
        INCORRECT_FEATURES: formatMessage(componentMessages['user.features.incorrectFeatures']),
        INCORRECT_ROLE: formatMessage(componentMessages['user.me.incorrectRole']),
    });
    const errorMessage = errorMapping.current[errorCode];
    if (CustomErrorPage) {
        return (React.createElement(CustomErrorPage, { errorCode: errorCode, errorText: errorMessage }));
    }
    return (React.createElement("div", { "data-testid": errorCode },
        React.createElement("p", null, errorMessage)));
};
//# sourceMappingURL=UserContextError.js.map